import { StepName } from './config/Wizard';

type WhatsNewNavigationStore = {
  eventPhotoStore: {
    selectedCampaignId: number | null;
    selectCampaign: (campaignId: number | null) => void;
  };
  wizardStore: {
    currentStepName: StepName;
    setStep: (step: StepName) => void;
  };
};

export const handleWhatsNewBack = (store: WhatsNewNavigationStore): boolean => {
  if (store.wizardStore.currentStepName !== StepName.WHATS_NEW) {
    return false;
  }

  if (store.eventPhotoStore.selectedCampaignId !== null) {
    store.eventPhotoStore.selectCampaign(null);
  } else {
    store.wizardStore.setStep(StepName.REGISTRATION_SELECT_TRAINING);
  }

  return true;
};
